var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "article",
    {
      staticClass:
        "lpu-doctor-card d-flex flex-column bg-gray-0 position-relative",
      class: _setup.isMobile ? "rounded-15 pa-4 ga-4" : "rounded-24 pa-6",
      attrs: { "data-qa": "lpu_doctors_list_card" },
    },
    [
      _setup.isMobile
        ? _c(_setup.DoctorCardActions, {
            staticClass: "lpu-doctor-card__actions",
            attrs: {
              "doctor-id": _vm.doctor.id,
              "doctor-page-url": _vm.doctorPageUrl,
              size: 40,
              "rounded-class": "rounded-15",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex",
          class: _setup.isMobile
            ? "flex-column ga-4"
            : "flex-row ga-6 align-start",
        },
        [
          _c(_setup.DoctorCardHeader, {
            attrs: { doctor: _vm.doctor, "doctor-page-url": _vm.doctorPageUrl },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex flex-column min-w-0 flex-grow-1",
              class: _setup.isMobile ? "ga-4" : "ga-3",
            },
            [
              _c(_setup.DoctorCardIdentity, {
                attrs: {
                  doctor: _vm.doctor,
                  "doctor-page-url": _vm.doctorPageUrl,
                },
              }),
              _vm._v(" "),
              _c(_setup.DoctorDocumentsPlate, {
                attrs: {
                  doctor: _vm.doctor,
                  "documents-url": `${_vm.doctorPageUrl}#documents`,
                },
              }),
              _vm._v(" "),
              _setup.isStaff &&
              !_setup.isMobile &&
              _vm.doctor.degree_education?.title
                ? _c(
                    "div",
                    {
                      staticClass:
                        "adminka-box d-inline-flex align-self-start pa-1 my-1",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.doctor.degree_education.title) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _setup.isMobile
                ? [
                    _setup.positiveRate
                      ? _c("div", { staticClass: "lpu-doctor-card__divider" })
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.positiveRate
                      ? _c(_setup.DoctorCardReview, {
                          attrs: {
                            "with-icon": "",
                            href: `${_vm.doctorPageUrl}#otzivi`,
                            text: _setup.positiveRate,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.showPriceBlock || _setup.clinicLoyaltyProgram
                      ? _c("div", { staticClass: "lpu-doctor-card__divider" })
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(_setup.DoctorCardOffer, {
                attrs: {
                  value: _setup.placeType,
                  "min-prices": _vm.doctor.min_prices,
                  "show-price-block": _setup.showPriceBlock,
                  "loyalty-program": _setup.clinicLoyaltyProgram || undefined,
                },
                on: {
                  input: function ($event) {
                    _setup.placeType = $event
                  },
                },
              }),
              _vm._v(" "),
              _setup.positiveRate && !_setup.isMobile
                ? _c(_setup.DoctorCardReview, {
                    attrs: {
                      href: `${_vm.doctorPageUrl}#otzivi`,
                      text: _setup.positiveRate,
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _setup.showRightColumn
            ? _c(
                "div",
                {
                  staticClass:
                    "lpu-doctor-card__schedule d-flex flex-column flex-shrink-0 ga-6",
                  class: {
                    "lpu-doctor-card__schedule--desktop": !_setup.isMobile,
                  },
                },
                [
                  _setup.isMobile
                    ? _c("div", { staticClass: "lpu-doctor-card__divider" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.doctor.has_restriction_appointment
                    ? _c(_setup.DoctorRestrictionsBanner, {
                        attrs: { "doctor-id": _vm.doctor.id, lpu: _vm.lpu },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(_setup.DoctorCardAppointment, {
                    attrs: {
                      doctor: _vm.doctor,
                      "lpu-phone-href": _setup.lpuPhoneHref,
                      "lpu-not-working-text": _vm.lpuNotWorkingText,
                      "home-call-label": _setup.homeCallLabel,
                      "staff-appointment-type": _setup.staffAppointmentType,
                      "place-type": _setup.placeType,
                      "day-items": _setup.dayItems,
                      "active-date": _setup.activeDate || undefined,
                      "active-day-slots": _setup.activeDaySlots,
                      "show-appointment-block": _setup.showAppointmentBlock,
                      "show-calendar": _setup.showCalendar,
                      "show-appointment-stub": _setup.showAppointmentStub,
                      "show-home-call-button": _setup.showHomeCallButton,
                      "show-clinic-call-button": _setup.showClinicCallButton,
                      "is-card-slots-loading": _setup.isCardSlotsLoading,
                      "is-express-appointment": _setup.isExpressAppointment,
                      "is-express-closed": _setup.isExpressClosed,
                      "is-staff": _setup.isStaff,
                    },
                    on: {
                      "select-day": _setup.selectDay,
                      slot: _setup.onSlotClick,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }